import styled from 'styled-components'
import { theme, media } from '../../styles/_variables'

export const WidthContainer = styled.div`
  width: 100%;
  max-width: ${theme.maxWidth};
  margin-left: 50%;
  transform: translateX(-50%);
  padding: 0 16px;
  ${media.tablet`
    width: 100%;
    max-width: 100%;
  `}
  h3 {
    font-weight: 600;
    ${media.tablet`
      font-size: ${theme.fonts.size.subTitle};
    `}
  }
`

export const CenterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 32px 0;
  > div:nth-child(1) {
    ${media.tablet`
      width: auto;
    `}
  }
  > div:nth-child(2) {
    ${media.tabletS`
      width: 100%;
      > div {
        width: 100%;
        > div {
          width: 100%;
        }
      }
    `}
  }
`

export const Instruction = styled.p`
  font-size: ${theme.fonts.size.small};
`

export default WidthContainer



// WEBPACK FOOTER //
// ./src/pages/forget-password/styled.js